import { render, staticRenderFns } from "./QuestionConfig.vue?vue&type=template&id=ab775e78"
import script from "./QuestionConfig.vue?vue&type=script&lang=js"
export * from "./QuestionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports